import { render, staticRenderFns } from "./EditStaffPassModal.vue?vue&type=template&id=3e7e3d8a&scoped=true&"
import script from "./EditStaffPassModal.vue?vue&type=script&lang=js&"
export * from "./EditStaffPassModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStaffPassModal.vue?vue&type=style&index=0&id=3e7e3d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e3d8a",
  null
  
)

export default component.exports